import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { EmailTemplateTestComponent } from './email-template-test.component';

const routes: Routes = [
  { path: '', component: EmailTemplateTestComponent, data: { title: 'Test Email Templates' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmailTemplateTestRoutingModule {}

@NgModule({
  imports: [
    EmailTemplateTestRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [EmailTemplateTestComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmailTemplateTestModule {}
